import React, { useMemo } from "react";
import BarChart from "components/charts/BarChart";

// Props:
// - years: number[]
// - topProducts: string[] // top 10 product names
// - productTotalsByYear: Record<year, Record<productName, amount>>
const CAProductsTop10Chart = ({ years, topProducts, productTotalsByYear }) => {
  const { chartSeries, chartOptions } = useMemo(() => {
    const series = years.map((year) => ({
      name: String(year),
      data: topProducts.map((productName) => Number((productTotalsByYear[year] || {})[productName] || 0)),
    }));

    const options = {
      chart: { type: "bar", stacked: true, toolbar: { show: false } },
      plotOptions: { bar: { horizontal: true, barHeight: "70%", borderRadius: 4 } },
      xaxis: {
        categories: topProducts,
        labels: { formatter: (v) => new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v) },
        title: { text: "Montant HT (DH)" },
      },
      yaxis: { labels: { style: { fontSize: "12px" } } },
      dataLabels: {
        enabled: true,
        formatter: (val) => new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val) + " DH",
        style: { fontSize: "12px", fontWeight: "bold", colors: ["#374151"] },
        background: { enabled: true, borderRadius: 6, borderWidth: 0, opacity: 0.85, dropShadow: { enabled: false } },
      },
      tooltip: {
        theme: 'dark',
        y: { formatter: (val) => new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val) + " DH" },
      },
      legend: { position: "top", horizontalAlign: "right" },
      colors: ["#0d9488", "#0284c7", "#2563eb", "#4f46e5", "#7c3aed"],
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.3,
          opacityFrom: 1,
          opacityTo: 0.75,
          stops: [0, 100],
        },
      },
      grid: { strokeDashArray: 4 },
    };

    return { chartSeries: series, chartOptions: options };
  }, [years, topProducts, productTotalsByYear]);

  return (
    <BarChart chartData={chartSeries} chartOptions={chartOptions} width="100%" height={600} />
  );
};

export default CAProductsTop10Chart;
